import { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { UseConsultantOrdersReport } from "./UseConsultantOrdersReport";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import OrderDeliveryDetails from "./ConsultantOrdersDetails";
import DatePickerCom from "../Sell/DatePickerCom";

export default function ConsultantOrdersReport(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { myPc, updatePage, updateSort } = UseMyPC();
  const { GetConsultantOrdersReport, GetConsultantOrderDetail } =
    UseConsultantOrdersReport();
  const [reportRes, setReportRes] = useState();
  const [state, setState] = useState({
    date1: "",
    date2: "",
  });
  const [openDialoge, setOpenDialoge] = useState({
    show: false,
    model: undefined,
  });
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    if (state.date1 == undefined || state.date2 == undefined) {
      return;
    }
    if ((state.date1 && state.date2) || (!state.date1 && !state.date2)) {
      setProgress(true);
      GetConsultantOrdersReport(state, myPc, true, (callback) => {
        setReportRes(callback);
      });
    }
  }, [myPc, state]);

  const columns = [
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "fullname",
      width: 250,
      align: "center",
      headerName: "مشاور",
      headerAlign: "center",
      sortable: false,
    },

    {
      field: "orderCount",
      headerName: "تعداد سفارش",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.orderCount ? toMoney(cellValues.row.orderCount) : 0}
          </Typography>
        );
      },
    },
    {
      field: "جزئیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "جزئیات",
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setProgress(true);
              GetConsultantOrderDetail(cellValues.row.id, state, (callback) => {
                setOpenDialoge({ show: true, model: callback });
              });
            }}
          >
            جزئیات
          </Button>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/consulatororders" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 2 }}>
          <DatePickerCom state={state} setState={setState} />
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setState({ date1: "", date2: "" });
            }}
          >
            حذف
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {reportRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.pageCount
                  : 1
              }
              rows={reportRes ? reportRes.items : []}
              paginationMode="server"
              page={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.page - 1
                  : 1
              }
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.totalItemCount
                  : 1
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount:
                    reportRes && reportRes.pageCondition
                      ? reportRes.pageCondition.totalItemCount
                      : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
      {openDialoge.show && (
        <OrderDeliveryDetails
          setOpenDialoge={setOpenDialoge}
          openDialoge={openDialoge}
        />
      )}
    </Detail>
  );
}
